// onboardingAllowlist — Controlled Onboarding cohort gate.
//
// Re-enabling Google OAuth (Controlled Onboarding Release Readiness, 2026-06-20)
// reopens the self-serve account path that Public Access Lockdown deliberately
// closed. To keep onboarding INVITE-ONLY for the controlled cohort (≤25), every
// OAuth session is checked against this allowlist at /auth/callback. Admins
// (REACT_APP_ADMIN_EMAILS) are always admitted so an operator can never be
// locked out of their own platform.
//
// Fail-closed: an email is admitted ONLY if it appears on the onboarding
// allowlist OR the admin allowlist. An empty/unset onboarding list admits no
// one (except admins) — so re-enabling OAuth can NEVER reopen unrestricted
// public signup. Mirrors the AdminRoute parsing convention (comma-separated,
// trimmed, case-insensitive).
//
// NOTE ON ENFORCEMENT SURFACE: this gate runs in-app, after the Supabase OAuth
// round-trip has resolved a session. A non-cohort user is signed out
// immediately and never reaches a protected route, gets no entitlement (free
// tier, RLS-isolated, no data). A *pre-creation* hard block would require a
// Supabase "Before User Created" auth hook (dashboard/edge config — out of
// scope for this initiative). RLS + entitlement remain the hard data boundary.

function parseList(raw) {
  return (raw || "")
    .split(",")
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
}

// The invited controlled-onboarding cohort.
export function getOnboardingAllowlist() {
  return parseList(process.env.REACT_APP_ONBOARDING_ALLOWLIST);
}

// Platform admins/operators — always admitted (same source as AdminRoute).
export function getAdminAllowlist() {
  return parseList(process.env.REACT_APP_ADMIN_EMAILS);
}

// True iff `email` is on the controlled-onboarding allowlist or is an admin.
// Fail-closed on a missing / blank / non-string email.
export function isOnboardingAllowed(email) {
  if (!email || typeof email !== "string") return false;
  const normalized = email.trim().toLowerCase();
  if (!normalized) return false;
  return (
    getOnboardingAllowlist().includes(normalized) ||
    getAdminAllowlist().includes(normalized)
  );
}
